import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { CommonService } from "src/app/services/common.service";
import { ApiService } from "src/app/services/api.service";
import endpoints from "src/app/helpers/endpoints";
import { takeUntil } from "rxjs/operators";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Subject } from "rxjs";
import { ErrorType } from "src/app/enums/error-type.enum";
import { MatDialog } from "@angular/material/dialog";
import { FileClaimDetailComponent } from "src/app/pages/file-claim/file-claim-listing/file-claim-detail/file-claim-detail.component";
import { ClaimChangesLogModalComponent } from "src/app/pages/customer-dashboard/components/modals/claim-changes-log-modal/claim-changes-log-modal.component";
import { FileClaimHistoryComponent } from "src/app/pages/file-claim/file-claim-listing/file-claim-history/file-claim-history.component";
import { FileClaimStatusChangeModalComponent } from "src/app/pages/file-claim/file-claim-listing/file-claim-status-change-modal/file-claim-status-change-modal.component";
import { FormGroup } from "@angular/forms";
import { EventService } from "src/app/services/event.service";
import { ClaimNotesComponent } from "src/app/pages/file-claim/file-claim-listing/claim-notes/claim-notes.component";
import { ClaimActionsService } from "src/app/pages/customer-dashboard/services/claim-actions.service";
import { AttachDocumentsComponent } from "src/app/pages/file-claim/file-claim-listing/attach-documents/attach-documents.component";
import { ViewAssignedTechnicianComponent } from "src/app/pages/customer-dashboard/components/modals/view-assigned-technician/view-assigned-technician.component";
import { Router } from "@angular/router";

@Component({
  selector: "fury-claim-table",
  templateUrl: "./claim-table.component.html",
  styleUrls: ["./claim-table.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ClaimTableComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  @Output() fetchClaimData = new EventEmitter<boolean>();
  @Input() dataSource = [];
  @Input() searchForm: FormGroup;
  @Input() columns = [
    { name: "Priority", property: "priority", visible: true },
    { name: "Created At", property: "createdAt", visible: true },
    { name: "Agreement Number", property: "agreementNumber", visible: true },
    { name: "Claim Number", property: "fileClaimNumber", visible: true },
    { name: "Status", property: "status", visible: true },
    { name: "First Name", property: "firstName", visible: true },
    { name: "Last name", property: "lastName", visible: true },
    { name: "Phone Number", property: "phoneNumber", visible: true },
    { name: "Email Address", property: "emailAddress", visible: true },
    { name: "Address", property: "address", visible: true },
    { name: "City", property: "city", visible: true },
    { name: "State", property: "state", visible: true },
    { name: "Zip", property: "zip", visible: true },
    { name: "Covered Item", property: "coveredItem", visible: true },
    { name: "Transaction Id", property: "transactionId", visible: true },
    { name: "Card Type", property: "cardType", visible: true },
    { name: "Amount", property: "amount", visible: true },
    { name: "Availability", property: "availability", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  status = [];
  @Input() services = [];
  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private apiservice: ApiService,
    private eventService: EventService,
    private claimActionsService: ClaimActionsService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getAllStatus();
    this.fetchFileClaimList();
  }

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  openDetails(row: any) {
    const obj = {
      width: "600px",
      data: row,
      panelClass: "custom-modalbox",
    };
    this.dialog.open(FileClaimDetailComponent, obj);
  }
  handleClaimChangesLog(rowData: any) {
    this.dialog
      .open(ClaimChangesLogModalComponent, {
        data: rowData?.fileClaimId,
        width: "1000px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {});
  }
  handleClaimHistory(row: any) {
    if (!row?.fileClaimId) return;
    this.apiservice
      .get(
        endpoints.fileAClaim.getClaimAssignmentHistory(row?.fileClaimId) +
          `?page=1&size=10`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            let obj = {
              width: "900px",
              data: {
                claimHistory: res.body.users,
                fileClaimId: row?.fileClaimId,
              },
            };
            this.dialog.open(FileClaimHistoryComponent, obj);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiservice.alert(err.message, ErrorType.Error);
        },
      });
  }

  changeStatus(row: any) {
    const obj = { width: "400px", disableClose: true, data: row };
    const dialogRef = this.dialog.open(
      FileClaimStatusChangeModalComponent,
      obj
    );
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        if (result) {
          this.fetchClaimData.emit(true);
        }
      });
  }
  search() {
    this.fetchClaimData.emit(true);
  }
  getAllStatus() {
    this.eventService.getClaimStatus$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((status: any[]) => {
        this.status = status;
      });
  }
  handleClaimNote(rowData: any) {
    this.dialog
      .open(ClaimNotesComponent, {
        data: {fileClaimId: rowData?.fileClaimId, fileClaimNumber: rowData?.fileClaimNumber},
        width: "1000px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {});
  }
  handleAssignTechnician(row: any, modalName: string){
    this.claimActionsService.openActionModal(row?.fileClaimId, modalName,  this.services, row?.propertyAddress?.zip);
  }
  fetchFileClaimList(){
    this.claimActionsService.shouldFetchFileClaimList$
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((res: boolean)=>{
      if(res){
        this.fetchClaimData.emit(true);
      }
    })
  }
  handleTechnicianSchedule(row: any, modalName: string){
    this.claimActionsService.openActionModal(row?.fileClaimId, modalName);
  }

    handleAttachDocument(rowData: any) {
      this.dialog
        .open(AttachDocumentsComponent, {
          data: {claimId : rowData?.fileClaimId},
          width: "900px",
          panelClass: "payment-info",
        })
        .afterClosed()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: any) => {
        });
    }
  handleViewAssignedTechnician(rowData: any) {
    this.dialog
      .open(ViewAssignedTechnicianComponent, {
        data: {...rowData, services: this.services},
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: boolean) => {
        if(res){
          this.fetchClaimData.emit(true);
        }
      });
  }
  redirectToViewClaim(claimDetails: any) {
    this.router.navigateByUrl(`/customer-dashboard/${claimDetails?.userId}/view-claim/${claimDetails?.fileClaimId}`);
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
